module.exports = __webpack_public_path__ + "img/gongan.250c9111.png";